var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-general-component" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.name.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: () => (_vm.isShowTitleInfo = false),
                  expression: "() => isShowTitleInfo = false",
                },
              ],
              staticClass: "room-setting-info-btn",
              on: {
                click: function ($event) {
                  _vm.isShowTitleInfo = !_vm.isShowTitleInfo
                },
              },
            },
            [
              _vm.isShowTitleInfo
                ? _c("span", { staticClass: "info-tooltip" }, [
                    _vm._v(_vm._s(_vm.$t("setting.name.valid"))),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" " + _vm._s(_vm.$t("setting.name.text")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.roomTitle,
              expression: "roomTitle",
            },
          ],
          staticClass: "room-setting-input",
          attrs: { type: "text", name: "roomTitle", maxlength: "35" },
          domProps: { value: _vm.roomTitle },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.roomTitle = $event.target.value
              },
              function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "roomTitle",
                  value: _vm.roomTitle,
                })
              },
            ],
          },
        }),
        _c("span", { staticClass: "room-title-count" }, [
          _vm._v(_vm._s(_vm.roomTitle.length) + "/35"),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c(
          "p",
          { staticClass: "room-setting-content-text sub-text main-color" },
          [_vm._v(_vm._s(_vm.$t("setting.name.link")))]
        ),
      ]),
    ]),
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.disclosure.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.disclosure.text"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isPublic,
                expression: "isPublic",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "radio", name: "setPublicMode" },
            domProps: { value: true, checked: _vm._q(_vm.isPublic, true) },
            on: {
              change: [
                function ($event) {
                  _vm.isPublic = true
                },
                function ($event) {
                  return _vm.CHANGE_SETTING_DATA({
                    type: "definePasswd",
                    value: !_vm.isPublic,
                  })
                },
              ],
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("setting.disclosure.public")))]),
        ]),
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isPublic,
                expression: "isPublic",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "radio", name: "setPublicMode" },
            domProps: { value: false, checked: _vm._q(_vm.isPublic, false) },
            on: {
              change: [
                function ($event) {
                  _vm.isPublic = false
                },
                function ($event) {
                  return _vm.CHANGE_SETTING_DATA({
                    type: "definePasswd",
                    value: !_vm.isPublic,
                  })
                },
              ],
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("setting.disclosure.private")))]),
        ]),
      ]),
      !_vm.isPublic
        ? _c("div", { staticClass: "room-setting-input-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.roomPassword,
                  expression: "roomPassword",
                },
              ],
              ref: "passwordInput",
              staticClass: "room-setting-input",
              attrs: {
                type: "password",
                name: "roomSetPwd",
                placeholder: _vm.$t("setting.disclosure.password.alert"),
                autoComplete: "off",
                maxlength: "20",
              },
              domProps: { value: _vm.roomPassword },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.roomPassword = $event.target.value
                  },
                  function ($event) {
                    return _vm.CHANGE_SETTING_DATA({
                      type: "passwd",
                      value: _vm.roomPassword,
                    })
                  },
                ],
                focus: function ($event) {
                  _vm.isShowPasswordBtn = false
                },
                blur: function ($event) {
                  _vm.isShowPasswordBtn = true
                },
              },
            }),
            _vm.isShowPasswordBtn && !!_vm.roomPassword
              ? _c(
                  "div",
                  {
                    staticClass: "room-pwd-show",
                    on: {
                      mouseover: function ($event) {
                        _vm.$refs.passwordInput.type = "text"
                      },
                      mouseleave: function ($event) {
                        _vm.$refs.passwordInput.type = "password"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("setting.disclosure.password.see")))]
                )
              : _vm._e(),
            _vm.validatePasswordText
              ? _c("p", { staticClass: "password-validate-text" }, [
                  _vm._v(_vm._s(_vm.validatePasswordText)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }